export default {
  art: [
    [
      { 
        text: 'selbstgenutztes Eigentum',
        value: 'SELBST',
        shortunit: 'qm',
        longunit: '' 
      },
      { 
        text: 'Garage/Abstellplatz', 
        value: 'GARAGE',
        shortunit: '',
        longunit: '' 
      },
      { 
        text: 'unbebautes Grundstück', 
        value: 'UNBEBAUT',
        shortunit: 'qm',
        longunit: '' 
      }
    ],
    [
      { 
        text: 'gemietetes gewerbliches Objekt', 
        value: 'MIET',
        shortunit: '€',
        longunit: 'Jahresbruttomiete '  
      },
      { 
        text: 'Garage/Abstellplatz', 
        value: 'GARAGE',
        shortunit: '',
        longunit: '' 
      },
      { text: 'unbebautes Grundstück', 
        value: 'UNBEBAUT',
        shortunit: 'qm',
        longunit: '' 
      }
    ],
    [
      { text: 'vermietetes/verpachtetes gew. Objekt',
        value: 'VERMIET',
        shortunit: '€',
        longunit: 'Jahresbruttomiete '
      },
      {
        text: 'Garage/Abstellplatz',
        value: 'GARAGE',
        shortunit: '',
        longunit: ''
      },
      {
        text: 'unbebautes Grundstück',
        value: 'UNBEBAUT',
        shortunit: 'qm',
        longunit: ''
      }
    ]
  ],
  bezug: [
    'Eigentümer',
    'Mieter/Pächter',
    'Vermieter/Verpächter'
  ],
  unit: {
    SELBST: 'überdachte Fläche in qm',
    VERMIET: 'Jahresbruttomiete in € (inklusive Nebenkosten)',
    MIET: 'Jahresbruttomiete in € (inklusive Nebenkosten)',
    GARAGE: 'Anzahl Garagen/Abstellplätze',
    UNBEBAUT: 'Fläche in qm'
  },
  errortext: {
    SELBST: 'qm bei überdachten Flächen',
    VERMIET: '€ Jahresbruttomiete',
    MIET: '€ Jahresbruttomiete',
    GARAGE: 'Anzahl Garagen/Abstellplätze',
    UNBEBAUT: 'qm Fläche'
  },
  valerrortext: {
    SELBST: 'qm-Angabe',
    VERMIET: '€-Angabe',
    MIET: '€-Angabe',
    GARAGE: 'Anzahl Garagen/Abstellplätze',
    UNBEBAUT: 'qm-Angabe'
  },
  rules: {
    SELBST: "required|numeric|min_value:1|max_value:50000",
    VERMIET: "required|numeric|min:3|min_value:100|max_value:24000",
    MIET: "required|numeric|min:3|min_value:100|max_value:24000",
    GARAGE: "required|numeric|min_value:1|max_value:1",
    UNBEBAUT: "required|numeric|min_value:1|max_value:500000",
  }
};
